import api from "@api";
import { ImagePreview } from "vant";
const docReg = /(\.doc)$|(\.ppt)|(\.pdf)|(\.xlsx?)$/;
const imageReg = /(\.png)$|(\.jpg)$|(\.jpeg)$/

export default {
    methods: {
        previewFile(file) { //文件预览
            if (docReg.test(file.path)) {   //文档预览服务预览
                let url = api.viewFile + "?filePath=" + file.path;
                window.open(url, "_blank")
            } else if (imageReg.test(file.path)) {  //图片
                let url = api.viewImageFile + file.path;
                if (navigator.userAgent.match(/(iPhone|iPod|Android|ios|iPad)/i)) {
                    ImagePreview([url]);
                } else {
                    window.open(url, "_blank")
                }

            } else {
                let url = api.viewImageFile + file.path;
                window.open(url, "_blank")
            };
        },
        downloadFile(file) {
            let url = api.viewImageFile + file.path;
            window.open(url, "_blank")
        }
    },
};